"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ramda = require("ramda");

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

var _components = require("../../components");

var _utils = require("../../utils");

var _flexItem = _interopRequireDefault(require("./flex-item"));

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Pretitle = _styledComponents["default"].span.withConfig({
  displayName: "flex-block-one__Pretitle",
  componentId: "sc-14aug7l-0"
})(["text-transform:uppercase;letter-spacing:4px;"]);

var propTypes = {
  /** Background color */
  backgroundColor: _propTypes.string,

  /** Background Image path */
  backgroundImage: _propTypes.string,

  /** setting for bottom padding amount */
  bottomUnitPadding: _propTypes.number,

  /** Component container class name */
  className: _propTypes.string,

  /** setting for number of columns */
  columns: (0, _propTypes.oneOf)([3, 4]),

  /** custom Tag for container */
  customBackground: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string, _propTypes.object]),

  /** A boolean to set whether the dark version of the cta is used */
  darkUi: _propTypes.bool,

  /** Description text usually a text, but can be a React component */
  description: _propTypes.node,

  /** Html ID for component container */
  htmlId: _propTypes.string,

  /** Image source */
  imageAbove: _propTypes.node,

  /** Image source */
  imageBelow: _propTypes.node,

  /** An array of items to render as flex items */
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  })),

  /** PreTitle text usually a text, but can be a React component */
  pretitle: _propTypes.node,

  /** Theme for Grid */
  theme: _utils.themePropType,

  /** Title text text usually a text, but can be a React component */
  title: _propTypes.node,

  /** setting for top padding amount */
  topUnitPadding: _propTypes.number
};
var defaultProps = {
  bottomUnitPadding: 2,
  columns: 3,
  topUnitPadding: 2
};

var updateHeights = function updateHeights(titles, setRowHeights) {
  var rowLevel = [];
  var titleHeights = [];
  titles.forEach(function (title, index) {
    titleHeights[index] = title.offsetHeight;
    rowLevel[index] = title.offsetTop;
  });
  var rows = (0, _ramda.uniq)(rowLevel).map(function (val) {
    var levelHeights = titleHeights.slice(rowLevel.indexOf(val), rowLevel.lastIndexOf(val) + 1);
    var height = (0, _ramda.reduce)(_ramda.max, -1, levelHeights);
    return (0, _ramda.repeat)(height, levelHeights.length);
  });
  setRowHeights((0, _ramda.flatten)(rows));
};

var FlexBlockOne = function FlexBlockOne(_ref) {
  var backgroundColor = _ref.backgroundColor,
      backgroundImage = _ref.backgroundImage,
      bottomUnitPadding = _ref.bottomUnitPadding,
      columns = _ref.columns,
      topUnitPadding = _ref.topUnitPadding,
      className = _ref.className,
      customBackground = _ref.customBackground,
      description = _ref.description,
      pretitle = _ref.pretitle,
      title = _ref.title,
      darkUi = _ref.darkUi,
      htmlId = _ref.htmlId,
      items = _ref.items,
      theme = _ref.theme,
      imageAbove = _ref.imageAbove,
      imageBelow = _ref.imageBelow;

  var _useState = (0, _react.useState)([]),
      titles = _useState[0];

  var _useState2 = (0, _react.useState)([]),
      rowHeights = _useState2[0],
      setRowHeights = _useState2[1];

  var updateHeightsCallback = (0, _react.useCallback)(function () {
    updateHeights(titles, setRowHeights);
  }, [titles, setRowHeights]);
  (0, _react.useEffect)(function () {
    window.addEventListener("resize", updateHeightsCallback);
    window.addEventListener("DOMContentLoaded", updateHeightsCallback);
    updateHeights(titles, setRowHeights);
    return function () {
      window.removeEventListener("resize", updateHeightsCallback);
      window.removeEventListener("DOMContentLoaded", updateHeightsCallback);
    };
  }, [titles, updateHeightsCallback]);
  var descriptionFont = {
    color: darkUi ? "text-light" : "text",
    fontSize: [3, 3, 4, 4, 5],
    fontWeight: 1,
    letterSpacing: "0.5px",
    lineHeight: [2, 2, 3],
    textAlign: "center"
  };
  var pretitleFont = {
    color: darkUi ? "text-light" : "text",
    fontSize: 2,
    fontWeight: 1,
    lineHeight: 3,
    mb: 4,
    textAlign: "center"
  };
  var titleFont = {
    color: darkUi ? "text-light" : "title",
    fontSize: [8, 9, 11, 11, 11, 11],
    fontWeight: 2,
    lineHeight: [2, 2, 1, 1, 1, 1],
    mb: [1, 3],
    textAlign: "center"
  };
  var gridColumns = columns === 3 ? [6, 8, 4, 4, 4, 4] : [6, 8, 3, 3, 3, 3];
  var defaultBg = darkUi ? "background-dark" : "background";
  return /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Wrapper, {
    alignItems: "center",
    backgroundColor: backgroundColor || defaultBg,
    backgroundImage: backgroundImage,
    className: className,
    htmlId: htmlId,
    justifyContent: "center",
    tag: customBackground
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    pb: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return bottomUnitPadding * padding;
    }),
    pt: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return topUnitPadding * padding;
    }),
    width: 1
  }, (description || title || pretitle) && /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Container, {
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, {
    alignItems: "center",
    columns: [6, 8, 10, 10, 10, 10],
    flexDirection: "column",
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_components.PanelContent, {
    alignItems: "center",
    description: description,
    descriptionFont: descriptionFont,
    imageAbove: imageAbove,
    imageBelow: imageBelow,
    imageSpacing: 4,
    justifyContent: "center",
    mb: 4,
    pretitle: pretitle && /*#__PURE__*/_react["default"].createElement(Pretitle, null, pretitle),
    pretitleFont: pretitleFont,
    title: title,
    titleFont: titleFont
  }))), /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Container, {
    className: className,
    id: htmlId,
    my: "-32px",
    width: 1
  }, items.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_flexItem["default"], _extends({
      key: item.id,
      columns: gridColumns,
      darkUi: darkUi,
      index: index,
      titleHeight: rowHeights[index],
      titleRef: function titleRef(ref) {
        titles[index] = ref;
        return ref;
      },
      updateHeightsCallback: updateHeights
    }, item));
  }))));
};

FlexBlockOne.propTypes = propTypes;
FlexBlockOne.defaultProps = defaultProps;
FlexBlockOne.displayName = "Modules.FlexBlockOne";

var _default = (0, _styledComponents.withTheme)(FlexBlockOne);

exports["default"] = _default;